module.exports = ".dev-info {\n  position: absolute;\n  right: 0;\n  z-index: 1001;\n  background-color: black;\n  color: white;\n  padding: 8px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main